import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { TimeFilterConfig } from '@frontend/sports/common/client-config-data-access';
import { Observable, of } from 'rxjs';

import { RedirectHelperService } from '../navigation-core/redirect-helper.service';
import { SportUrlParam, UrlHelperService } from '../navigation-core/url-helper.service';

@Injectable({ providedIn: 'root' })
export class CalendarRedirectGuard {
    constructor(
        private timeFilterConfig: TimeFilterConfig,
        private urlHelper: UrlHelperService,
        private redirectHelperService: RedirectHelperService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        if (this.timeFilterConfig.isTimeFilterEnabled) {
            const defaultUrl = route.params?.sport ? this.getCalendarUrl(route) : '';
            if (defaultUrl) {
                this.redirectHelperService.goToPage(defaultUrl);
            }

            return of(false);
        }

        return of(true);
    }

    private getCalendarUrl(route: ActivatedRouteSnapshot): string {
        return this.urlHelper.getSportUrl({ id: route.params.sport, name: route.params.sportName }, SportUrlParam.Today);
    }
}
